const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const Password = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PASSWORD_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PASSWORD_ERROR':
            return { loading: false, error: true, data: action.payload };
        case 'PASSWORD_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'PASSWORD_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default Password